import {
	AllowedFileTypes,
	MaxAllowedSizeForRenderXBytes,
} from '@sharefiledev/fileviewer-pilet-sdk';
import { getFileExtension } from '../../utils/getFileExtension';

export function isResourceAllowedForWatermark(
	fileName: string,
	fileSize: number
): boolean {
	const fileExtension = getFileExtension(fileName);
	return (
		AllowedFileTypes.includes(fileExtension) && fileSize < MaxAllowedSizeForRenderXBytes
	);
}
